module.exports = __webpack_public_path__ + "static/media/clear-search-icon.ef1576a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clear-search-icon.svg
// module id = 246
// module chunks = 0